import { ISelectedGameModel } from '@bg-shared/business/SelectedGames/interfaces';
import { ISelectedBettingOption } from '@bg-shared/interfaces/IBettingOption';
import { ILotteryGameState } from '@bg-shared/contexts/Games/Lottery/interfaces';
import { IBetslipGameState } from '@bg-shared/contexts/Games/interfaces/IBetslipGames';

export const formatSimpleOption = (
    game: IBetslipGameState,
    option: ISelectedGameModel,
): ISelectedBettingOption => ({
    ...option,
    ...game.data.bettingOptions[option.optionId],
    draw: {
        runId: game.data.runId,
        runRoundId: game.data.runRoundId,
        drawCode: game.data.drawCode,
        nextRunId: (game as ILotteryGameState).data.nextRunId,
        nextDrawCode: (game as ILotteryGameState).data.nextDrawCode,
        roundId: game.data.roundId,
    },
});
